export default "__VITE_ASSET__5ebc3195__"